module.exports = __webpack_public_path__ + "static/media/nightmare_boots.decf8d0b.png";